<template>
    <div class="i-wysiwyg">
        <btn @press="editWysiwyg" :l='label' i='pencil' size='medium' />
    </div>
</template>
<script>
import Editor from '@tinymce/tinymce-vue';
import tinyRu from './tinymce_ru.js';
import _ from 'lodash';
export default {
    components: {
        'vue-mce': Editor
    },
    name: 'i-wysiwyg',
    props: {
        value: String,
        label: String
    },

    mounted() {
        this.content = this.value;
    },
    methods: {
        editWysiwyg() {
            let self = this;
            _i.bus.$emit('edit-wysiwyg', { idx: this.idx, content: this.content });
            _i.bus.$once('save-wysiwyg', ({ idx, content }) => {
                console.log(idx)
                if (idx === self.idx) {
                    self.content = content;
                    self.$emit('input', content);
                }
            });
        },
        onLoadContent() {
            tinyMCE.addI18n('ru', tinyRu);
            tinyMCE.init({
                language: 'ru'
            });
        },
        onChange(v) {
            this.$emit('input', v.target.value);
        },
        onMessage(e) {},
        edit() {}
    },
    data() {
        let self = this;
        return {
            content: "",
            idx: _.random(0, 999999999),
            opened: false,
            frame_src: '',
            buffer: ""
        }
    }
}
</script>
<style lang="css" scoped>
.editor-frame {
    width: 100%;
    height: 100%;
    border: none;
}
</style>